import { render, staticRenderFns } from "./listDis.vue?vue&type=template&id=5781c188"
import script from "./listDis.vue?vue&type=script&lang=js"
export * from "./listDis.vue?vue&type=script&lang=js"
import style0 from "./listDis.vue?vue&type=style&index=0&id=5781c188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports